import React from "react";

import OrganizationAssign from "../../components/OrganizationAssign";

const OrganizationPageAssign = () => {
  return <OrganizationAssign />;
};

export default OrganizationPageAssign;
